import { render, staticRenderFns } from "./AppActionNeeded.vue?vue&type=template&id=7c0655c5&"
import script from "./AppActionNeeded.vue?vue&type=script&lang=js&"
export * from "./AppActionNeeded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports